/**
 * Standardized focus state styles for UI components.
 * These constants ensure consistent focus styling across all interactive elements.
 * Uses semantic color tokens (primary_button) defined in tailwind.config.js
 */

/**
 * Primary focus ring for buttons and interactive elements
 * - Visible ring with semantic primary color
 * - Ring offset for visual depth
 * - Works in both light and dark modes
 */
export const FOCUS_RING = "focus:outline-none focus:ring-2 focus:ring-primary_button focus:ring-offset-2 dark:focus:ring-offset-dark-background";

/**
 * Subtle focus style for input elements
 * - Ring without offset for compact appearance
 * - Works well on input fields and text areas
 * - Maintains visual hierarchy with button focus
 */
export const FOCUS_INPUT = "focus:outline-none focus:ring-2 focus:ring-primary_button";

/**
 * Alternative input focus with border highlight
 * - Used for inputs that need border-based feedback
 * - Combines border color change with subtle ring
 * - Good for date and text inputs
 */
export const FOCUS_INPUT_BORDER = "focus:outline-none focus:border-primary_button focus:ring-1 focus:ring-primary_button";

/**
 * Dropdown and menu focus state
 * - Minimal outline for focus visibility
 * - Suitable for dropdowns and menus
 */
export const FOCUS_MINIMAL = "focus:outline-none";

/**
 * Switch toggle focus state
 * - Ring with offset for toggle switches
 * - Visual consistency with button focus
 */
export const FOCUS_SWITCH = "focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary_button";
